import { Card } from '@chakra-ui/react';
import { IAccountHistoryResp } from '@monetize/types/app';
import { MCard, MText } from '../../../components/Monetize';
import { DateDisplay } from '../../../components/Monetize/DateDisplay';
import {
  AccountHistoryObjectTypeDisplayText,
  AccountHistoryOperationDisplayText,
} from '../../../constants/accounts';

const AccountHistoryDrawerItemCard = ({
  createDate,
  operation,
  objectType,
  message,
}: IAccountHistoryResp) => {
  return (
    <MCard variant="borderless">
      <Card.Body flex="1" flexDirection="column">
        <DateDisplay
          date={createDate}
          timezoneConfigKey="userTimezone"
          textProps={{
            fontWeight: 'normal',
            fontSize: 'sm',
            color: 'tGray.darkPurple',
          }}
        />
        <MText fontSize="md" fontWeight="bold" color="tPurple.base" mt={2}>
          {`${AccountHistoryOperationDisplayText[operation]} ${AccountHistoryObjectTypeDisplayText[objectType]}`}
        </MText>
        <MText fontSize="sm" fontWeight="normal" color="tPurple.base" mt={2}>
          {message}
        </MText>
      </Card.Body>
    </MCard>
  );
};

export default AccountHistoryDrawerItemCard;
